import React from 'react'
import './school-signup-component.scss'
import { Constants, ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import SchoolSignUp from '../../school-sign-up/school-sign-up'
import Loading from '../../common/loading/loading'
import Path from '../../routes/routes-path'
import MasterDataApi from '../../../apis/master-data'
import SchoolApi from '../../../apis/school'
import CommonApi from '../../../apis/common'
import SignupSuccessComponent from '../sign-up-success-component/sign-up-success-component'

let EVENT_ID = "630c4903ac18965247ec50a3"
class SchoolSignupComponent extends React.Component {
  state = {
    activeTabIndex: 1,
    classDropdownData: null,
    sectionDropdownData: null,
    boardDropdownData: null,
    staffTypesDropdown: null,
    isSignUpfailed: false,
    isEmailAlreadyRegistered: false,
    isLoginFailed: false,
    loading: false,
    signUpEmail: null,
    isSignupSuccess: false,
    name: "",
    eventName: 'F1 - Financial Literacy Challenge'
  }

  countryCodeHash = {}

  tabs = [{ name: 'Signup' }]

  componentDidMount() {
    this.getBoardDetails()
    this.getClassDetails()
    this.getStaffTypesDetails()
    this.getCountryCodes()
  }

  onCountryCodeSearch(value, index) {
    if (value.length > 2 || !value) {
      this.countryCodeIndex = index
      this.getCountryCodes({ name: `/${value}` })
    }
  }

  getBoardDetails() {
    let payload = { limit: 100, display: 'SHOW' }
    MasterDataApi.getBoard(payload)
      .then(boardData => {
        let items = []
        for (let i = 0; i < boardData.response.length; i++) {
          items.push({
            title: boardData.response[i].title,
            value: boardData.response[i].title
          })
        }

        this.setState({ boardDropdownData: items, boardDropdownLoading: false })
      })
      .catch(err => {
        this.setState({
          boardDropdownLoading: false
        })
      })
  }

  getClassDetails() {
    let payload = { limit: 100, sortType: 'asc', sortKey: 'title' }

    MasterDataApi.getClass(payload)
      .then(classData => {
        let items = []
        for (let i = 0; i < classData.response.length; i++) {
          if (classData.response[i].title == 'Class 5') continue
          items.push({
            title: classData.response[i].title,
            value: classData.response[i].title
          })
        }

        this.setState({
          classDropdownLoading: false,
          classDropdownData: items
        })
      })
      .catch(err => {
        this.setState({
          classDropdownLoading: false
        })
      })
  }

  getStaffTypesDetails() {
    let payload = { limit: 100 }
    payload.types = "nin/COORDINATOR"
    SchoolApi.getAllStaffTypes(payload)
      .then(staffTypes => {
        let items = []
        for (let i = 0; i < staffTypes.response.length; i++) {
          items.push({
            title: staffTypes.response[i].displayType,
            value: staffTypes.response[i].type
          })
        }
        this.setState({ staffTypesDropdown: items })
      })
      .catch(err => { })
  }

  getCountryCodes(payload = {}) {
    CommonApi.getCountryCodeList(payload)
      .then(response => {
        let data = response.response
        if (data.length) {
          this.setState({ countryList: data })
          let countryCodeDropdown = this.buildCountryCodeDropdown(data)
          this.setState({ countryCodeDropdown })
        }
      })
      .catch(err => { })
  }

  buildCountryCodeDropdown(list = []) {
    let countryCodeDropdown = []
    let localHash = {}
    for (let i = 0; i < list.length; i++) {
      let item = list[i]

      if (!localHash[item.dialCode]) {
        this.countryCodeHash[item.dialCode] = item
        localHash[item.dialCode] = item
        countryCodeDropdown.push({
          title: `${item.dialCode}`,
          addOn: item.name,
          value: item.dialCode
        })
      }
    }
    this.setState({ hashedCountryCode: this.countryCodeHash })
    return countryCodeDropdown
  }

  goToMenu() {
    this.props.history.replace(Path.DASHBOARD)
  }

  setSignupSuccess = name => {
    this.setState({
      isSignupSuccess: true,
      name: name
    })
  }

  render() {
    const { isSignupSuccess, name } = this.state
    return (
      <>
        {this.state.loading && <Loading />}
        <div className='mpl-signup-component-rms'>
          <div className='header row no-gutters'>
            <div className='col-6'>
              <a href='https://countingwell.com'>
                <img
                  alt=''
                  className='logo'
                  src={getImageSource(ImageConstants.CW_LOGO)}
                />
              </a>
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-7 col-md-6 col-sm-12 signup-container'>
              {!isSignupSuccess && (
                <>
                  <div className='row maths-day-container'>
                    <div class='col-lg-3 col-md-3 col-sm-12 maths-day-pos-container text-center'>
                      <img
                        alt=''
                        className='maths-day-pos'
                        src={getImageSource(ImageConstants.FLC)}
                      />
                    </div>
                    <div class='col-lg-9 col-md-9 col-sm-12 maths-day-description'>
                      <p className='slogan-text-signup'>
                        School Registration for
                        <h4><strong> F1 – Financial Literacy Challenge, 2022</strong></h4>
                      </p>
                      <p>
                        Countingwell is inviting schools to compete in a national level challenge for students of grade 6-9 to test their knowledge about Financial Literacy! Top 100 students all over India will win a Fyp zero balance card that can help them take the first step to learning to track and manage their own finances! Students will also get to take a quick course on maths concepts related to finance and a few short videos to prepare for the finals.
                      </p>
                    </div>
                  </div>
                  <div className='text-center sub-title'>Important Events &  Dates</div>
                  <div className="pt-4">
                    <ul className='row d-flex justify-content-center'>
                      <li className='col-lg-4 col-md-4 col-sm-12 important-dates'>
                        <div className='imd-steps'>
                          <img
                            alt=''
                            className='imd-steps-icn'
                            src={getImageSource(ImageConstants.GULF_CALENDAR_ICON)}
                          />
                          <img
                            alt=''
                            className='imd-steps-icn-1'
                            src={getImageSource(ImageConstants.GULF_CALENDAR_ICON_1)}
                          />
                        </div>
                        <p className='imp-date'>Warm-up Test and Qualifying Course</p>
                        <p>
                        Students take a quick warm-up test and complete a course to prepare for the finals.
                        </p>
                        <p>
                          <strong>Start anytime from 7.00 AM 1st September and complete before Midnight September 25th.</strong>
                        </p>
                      </li>
                      <li className='col-lg-4 col-md-4 col-sm-12 important-dates'>
                        <div className='imd-steps'>
                          <img
                            alt=''
                            className='imd-steps-icn-v2'
                            src={getImageSource(ImageConstants.IMD_CLOCK_ICON)}
                          />
                        </div>
                        <p className='imp-date'>Final Financial Literacy Challenge</p>
                        <p>
                        Show your knowledge of money and personal finance by taking the Final Challenge anytime between
                        </p>
                        <p>
                          <strong> 7.00 AM IST on 15th September to 7.00 PM IST on 1st October</strong>
                        </p>
                      </li>
                    </ul>
                  </div>
                </>
              )}
              {isSignupSuccess && <SignupSuccessComponent name={name} eventName={this.state.eventName} />}
            </div>
            <div className='col-lg-5 col-md-6 col-sm-12'>
              <div className='row center-box p-2'>
                {this.state.activeTabIndex == Constants.ACTIVE_TAB_SIGN_UP &&
                  this.state.boardDropdownData &&
                  this.state.staffTypesDropdown &&
                  this.state.countryCodeDropdown &&
                  this.state.classDropdownData && (
                    <SchoolSignUp
                      eventId={EVENT_ID}
                      classes={this.state.classDropdownData}
                      boards={this.state.boardDropdownData}
                      countries={this.state.countryCodeDropdown}
                      roles={this.state.staffTypesDropdown}
                      hashedCountryCode={this.state.hashedCountryCode}
                      isSignUpfailed={this.state.isSignUpfailed}
                      isEmailAlreadyRegistered={
                        this.state.isEmailAlreadyRegistered
                      }
                      delegate={this}
                      setSignupSuccess={this.setSignupSuccess}
                      {...this.props}
                    ></SchoolSignUp>
                  )}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default SchoolSignupComponent
